import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'

import history from './shared/architecture/history'


class SimpleMenu extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = (name) => {
    this.setState({ anchorEl: null });
    //Dispatch.nextAction('scroll', name)
    //document.getElementById('home').scrollIntoView()
    //document.getElementById('contact').scrollIntoView()
  //  e.preventDefault()
  };
  handleClickItem = name => {
    //history.push('/' + name)
    document.getElementById(name).scrollIntoView()
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div className='avenir'>
        <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <div className='f1 fl dark-gray'><FontAwesomeIcon icon={faBars} /></div>
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={e => this.handleClickItem('about')}><span className='w-100 f4 fw9 tc'>Us</span></MenuItem>
          <MenuItem onClick={e => this.handleClickItem('portfolio')}><span className='w-100 f4 fw9 tc'>Look Around</span></MenuItem>
          <MenuItem onClick={e => this.handleClickItem('contact')}><span className='w-100 f4 fw9 tc'>Communicate</span></MenuItem>
          <MenuItem> <a className='w-100 link black f4 fw9 tc' href='https://squareup.com/gift/YZFZW93HH4TA0/order'>Gift Cards</a></MenuItem>
          {/* <MenuItem onClick={e => this.handleClose('contact')}>Contact</MenuItem> */}
        </Menu>
      </div>
    );
  }
}

export default SimpleMenu;
